module.exports = __webpack_public_path__ + "static/media/benefit analysis.f1193ae0.png";